

export default {
  locale: 'hu',
  Pagination: {
    items_per_page: '/ oldal',
    jump_to: 'Ugrás',
    jump_to_confirm: 'megerősít',
    page: '',
    prev_page: 'Előző oldal',
    next_page: 'Következő oldal',
    prev_5: 'Előző 5 oldal',
    next_5: 'Következő 5 oldal',
    prev_3: 'Előző 3 oldal',
    next_3: 'Következő 3 oldal',
    page_size: 'Page Size'
  },
  DatePicker: {
    lang: {
      placeholder: 'Válasszon dátumot',
      yearPlaceholder: 'Válasszon évet',
      quarterPlaceholder: 'Válasszon negyedévet',
      monthPlaceholder: 'Válasszon hónapot',
      weekPlaceholder: 'Válasszon hetet',
      rangePlaceholder: ['Kezdő dátum', 'Befejezés dátuma'],
      rangeYearPlaceholder: ['Kezdő év', 'Befejezés éve'],
      rangeMonthPlaceholder: ['Kezdő hónap', 'Befejezés hónapja'],
      rangeWeekPlaceholder: ['Kezdő hét', 'Befejezés hete'],
      locale: 'hu_HU',
      today: 'Ma',
      now: 'Most',
      backToToday: 'Vissza a mai napra',
      ok: 'Ok',
      clear: 'Törlés',
      month: 'Hónap',
      year: 'Év',
      timeSelect: 'Időpont kiválasztása',
      dateSelect: 'Dátum kiválasztása',
      weekSelect: 'Hét kiválasztása',
      monthSelect: 'Hónap kiválasztása',
      yearSelect: 'Év kiválasztása',
      decadeSelect: 'Évtized kiválasztása',
      yearFormat: 'YYYY',
      dateFormat: 'YYYY/MM/DD',
      dayFormat: 'DD',
      dateTimeFormat: 'YYYY/MM/DD HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Előző hónap (PageUp)',
      nextMonth: 'Következő hónap (PageDown)',
      previousYear: 'Múlt év (Control + left)',
      nextYear: 'Jövő év (Control + right)',
      previousDecade: 'Előző évtized',
      nextDecade: 'Következő évtized',
      previousCentury: 'Múlt évszázad',
      nextCentury: 'Jövő évszázad'
    },
    timePickerLocale: {
      placeholder: 'Válasszon időt',
      rangePlaceholder: ['Kezdő idő', 'Befejezés ideje']
    }
  },
  TimePicker: {
    placeholder: 'Válasszon időt',
    rangePlaceholder: ['Kezdő idő', 'Befejezés ideje']
  },
  Calendar: {
    lang: {
      placeholder: 'Válasszon dátumot',
      yearPlaceholder: 'Válasszon évet',
      quarterPlaceholder: 'Válasszon negyedévet',
      monthPlaceholder: 'Válasszon hónapot',
      weekPlaceholder: 'Válasszon hetet',
      rangePlaceholder: ['Kezdő dátum', 'Befejezés dátuma'],
      rangeYearPlaceholder: ['Kezdő év', 'Befejezés éve'],
      rangeMonthPlaceholder: ['Kezdő hónap', 'Befejezés hónapja'],
      rangeWeekPlaceholder: ['Kezdő hét', 'Befejezés hete'],
      locale: 'hu_HU',
      today: 'Ma',
      now: 'Most',
      backToToday: 'Vissza a mai napra',
      ok: 'Ok',
      clear: 'Törlés',
      month: 'Hónap',
      year: 'Év',
      timeSelect: 'Időpont kiválasztása',
      dateSelect: 'Dátum kiválasztása',
      weekSelect: 'Hét kiválasztása',
      monthSelect: 'Hónap kiválasztása',
      yearSelect: 'Év kiválasztása',
      decadeSelect: 'Évtized kiválasztása',
      yearFormat: 'YYYY',
      dateFormat: 'YYYY/MM/DD',
      dayFormat: 'DD',
      dateTimeFormat: 'YYYY/MM/DD HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Előző hónap (PageUp)',
      nextMonth: 'Következő hónap (PageDown)',
      previousYear: 'Múlt év (Control + left)',
      nextYear: 'Jövő év (Control + right)',
      previousDecade: 'Előző évtized',
      nextDecade: 'Következő évtized',
      previousCentury: 'Múlt évszázad',
      nextCentury: 'Jövő évszázad'
    },
    timePickerLocale: {
      placeholder: 'Válasszon időt',
      rangePlaceholder: ['Kezdő idő', 'Befejezés ideje']
    }
  },
  global: {
    placeholder: 'Kérlek, válassz'
  },
  Table: {
    filterTitle: 'Szűrők',
    filterConfirm: 'Alkalmazás',
    filterReset: 'Visszaállítás',
    filterEmptyText: 'No filters',
    emptyText: 'Nincs adat',
    selectAll: 'Jelenlegi oldal kiválasztása',
    selectInvert: 'Jelenlegi oldal inverze',
    selectionAll: 'Összes adat kiválasztása',
    sortTitle: 'Rendezés',
    expand: 'Sor kinyitása',
    collapse: 'Sor becsukása',
    triggerDesc: 'Kattintson a csökkenő sorrendbe rendezéshez',
    triggerAsc: 'Kattintson a növekvő sorrendbe rendezéshez',
    cancelSort: 'Kattintson a rendezés visszavonásához',
    selectNone: 'Összes visszavonása'
  },
  Modal: {
    okText: 'Alkalmazás',
    cancelText: 'Visszavonás',
    justOkText: 'Alkalmazás'
  },
  Popconfirm: {
    okText: 'Alkalmazás',
    cancelText: 'Visszavonás'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Keresés',
    itemUnit: 'elem',
    itemsUnit: 'elemek',
    remove: 'Eltávolít',
    selectCurrent: 'Jelenlegi oldal kiválasztása',
    removeCurrent: 'Jelenlegi oldal eltávolítása',
    selectAll: 'Összes adat kiválasztása',
    removeAll: 'Összes adat eltávolítása',
    selectInvert: 'Jelenlegi oldal inverze'
  },
  Upload: {
    uploading: 'Feltöltés...',
    removeFile: 'Fájl eltávolítása',
    uploadError: 'Feltöltési hiba',
    previewFile: 'Fájl előnézet',
    downloadFile: 'Fájl letöltése'
  },
  Empty: {
    description: 'Nincs adat'
  },
  Icon: {
    icon: 'ikon'
  },
  Text: {
    edit: 'Szerkesztés',
    copy: 'Másolás',
    copied: 'Másolva',
    expand: 'Kiterjesztés'
  },
  PageHeader: {
    back: 'Vissza'
  }
};
